import { render, staticRenderFns } from "./CitiesManager.vue?vue&type=template&id=69d15cb3&"
import script from "./CitiesManager.vue?vue&type=script&lang=ts&"
export * from "./CitiesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports